<div class="login-page">
  <div class="login-banner-wrapper">
    <div class="login-banner">
      <div class="container login-container">
        <div class="logo mb-lg-5 mb-2">
          <div class="logo-wrapper">
            <img src="assets/images/login-registration/logo_rewards.svg" />
          </div>
        </div>
        <div class="login-form card rounded">
          <h5 class="login-title text-primary mb-0">
            <span class="visually-hidden">Login</span>
            {{ 'login.page.title' | translate }}
          </h5>
          <div class="panel-text mlb-text font-size-14 text-left">
            {{ 'login.page.description' | translate }}
          </div>
          <fgb-mlbam-user-login></fgb-mlbam-user-login>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="preview-container d-block">
      <h2 class="preview-title">
        {{ 'fgbcl.preview.title' | translate }}
      </h2>
      <div class="preview-subtitle font-size-14">
        {{ 'fgbcl.preview.subtitle' | translate }}
      </div>
    </div>
  </div>
</div>
